import constants from './constants';

const { EXCHANGE_STATUS } = constants;

const EXCHANGE_STATUS_DATA = {
  [EXCHANGE_STATUS.unassigned]: {
    id: EXCHANGE_STATUS.unassigned,
    name: 'Не назначен',
    color: 'ui-error',
  },
  [EXCHANGE_STATUS.market]: {
    id: EXCHANGE_STATUS.market,
    name: 'На бирже',
    color: 'ui-primary',
  },
  [EXCHANGE_STATUS.pending]: {
    id: EXCHANGE_STATUS.pending,
    name: 'Ждём подтверждения',
    color: 'ui-warning',
  },
  [EXCHANGE_STATUS.assigned]: {
    id: EXCHANGE_STATUS.assigned,
    name: 'Назначен',
    color: 'ui-success',
  },
};

const EXCHANGE_REQUEST_STATUS_DATA = {
  [EXCHANGE_STATUS.unassigned]: {
    id: EXCHANGE_STATUS.unassigned,
    name: 'Не назначен',
    color: 'ui-error',
    icon: '$ui-delete',
  },
  [EXCHANGE_STATUS.market]: {
    id: EXCHANGE_STATUS.market,
    name: 'Ожидаем подтверждения',
    color: 'ui-primary',
    icon: '$ui-time',
  },
  [EXCHANGE_STATUS.pending]: {
    id: EXCHANGE_STATUS.pending,
    name: 'Необходимо создать мероприятие',
    color: 'ui-warning',
    icon: '$ui-build',
  },
  [EXCHANGE_STATUS.assigned]: {
    id: EXCHANGE_STATUS.assigned,
    name: 'Мероприятие создано',
    color: 'ui-success',
    icon: '$ui-check',
  },
};

export default {
  EXCHANGE_STATUS_DATA,
  EXCHANGE_REQUEST_STATUS_DATA,
};
